module.exports = __webpack_public_path__ + "img/我的钱包.e90f7d04.png";